export default __webpack_public_path__ + "static/media/extraction.902386c5.svg";